/**
 * PositionViewModal - Модальное окно просмотра должности партнёра
 */
import React from 'react';
import {
  Modal,
  Text,
  Group,
  Stack,
  Badge,
  Button,
  Divider,
  Box,
} from '@mantine/core';
import { IconPencil, IconBriefcase, IconLock } from '@tabler/icons-react';
import tokens from '../../theme/designTokens';

/**
 * Форматирование даты
 */
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString('ru-RU', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Moscow',
  });
};

const PositionViewModal = ({ opened, onClose, position, onEdit }) => {
  if (!position) return null;

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Group gap="xs">
          <IconBriefcase size={20} color={tokens.colors.brand.primary} />
          <Text fw={600}>Должность партнёра</Text>
        </Group>
      }
      centered
      radius="lg"
      size="md"
    >
      <Stack gap="md">
        {/* Статусы */}
        <Group>
          {position.is_system && (
            <Badge
              color="violet"
              variant="light"
              radius="xl"
              size="lg"
              leftSection={<IconLock size={12} />}
            >
              Системная
            </Badge>
          )}
          {position.is_active ? (
            <Badge color="green" variant="light" radius="xl" size="lg">
              Активна
            </Badge>
          ) : (
            <Badge color="gray" variant="light" radius="xl" size="lg">
              Неактивна
            </Badge>
          )}
        </Group>

        {/* Название */}
        <Box>
          <Text size="xs" c="dimmed" tt="uppercase" fw={600} mb={4}>
            Название
          </Text>
          <Text size="lg" fw={500}>
            {position.name}
          </Text>
        </Box>

        {/* Порядок сортировки */}
        <Box>
          <Text size="xs" c="dimmed" tt="uppercase" fw={600} mb={4}>
            Порядок сортировки
          </Text>
          <Text size="sm">
            {position.sort_order}
          </Text>
        </Box>

        <Divider />

        {/* Метаданные */}
        <Group justify="space-between">
          <Box>
            <Text size="xs" c="dimmed">Создана</Text>
            <Text size="sm">{formatDate(position.created_at)}</Text>
          </Box>
        </Group>

        {position.updated_at !== position.created_at && (
          <Box>
            <Text size="xs" c="dimmed">Обновлена</Text>
            <Text size="sm">{formatDate(position.updated_at)}</Text>
          </Box>
        )}

        {/* Кнопки */}
        <Group justify="flex-end" gap="sm" mt="md">
          <Button variant="subtle" color="gray" onClick={onClose}>
            Закрыть
          </Button>
          <Button
            leftSection={<IconPencil size={16} />}
            onClick={() => onEdit(position)}
          >
            Редактировать
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default PositionViewModal;
